import { DATABASE } from "../../../config/firebase";
import { EarningConfig } from "../types/earning.data";

export const fetchEarningsConfig = async() => {
  return DATABASE.collection("config").doc("earning_config").get();
}

export const save = async(configs: EarningConfig[]) => {
  await DATABASE.collection("config").doc("earning_config").update({ "configs": configs });
}

export const fetchEarningsConfigsPaginated = async (limit: number, offset: number) => {
  try {
    const doc = await DATABASE.collection("config").doc("earning_config").get();
    const allConfigs = doc.data()?.configs || [];
    
    const totalCount = allConfigs.length;
    const startIndex = offset;
    const endIndex = Math.min(startIndex + limit, allConfigs.length);
    const pageConfigs = allConfigs.slice(startIndex, endIndex);
    
    return {
      configs: pageConfigs,
      totalCount
    };
  } catch (error) {
    console.log("fetchEarningsConfigsPaginated error: ", error);
    throw error;
  }
}

export const fetchAllEarningsConfigs = async () => {
  try {
    const doc = await DATABASE.collection("config").doc("earning_config").get();
    const allConfigs = doc.data()?.configs || [];
    return allConfigs;
  } catch (error) {
    console.log("fetchAllEarningsConfigs error: ", error);
    throw error;
  }
}